import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=6e75308a&scoped=true"
import script from "./infoPage.vue?vue&type=script&lang=js"
export * from "./infoPage.vue?vue&type=script&lang=js"
import style0 from "./infoPage.vue?vue&type=style&index=0&id=6e75308a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75308a",
  null
  
)

export default component.exports